export default __webpack_public_path__ + "locales/si/SharingPanel.json?hash=8f8f9c8e4427087dbb4336907f33ff8e";